import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {useTranslation} from "react-i18next";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    prompText: {
        marginTop: theme.spacing(2),
        height: '100%',
    },
    promptActions: {
        '& > *': {
            marginLeft: theme.spacing(1)
        }
    }
}));
export const ErrorMessage = ({
    errorType
}: any) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const message = errorType ?
        t(`_Common.Api.Messages.${errorType}`)
        : t('_Common.Api.Messages.UnknownError');

       return <Grid container className={classes.root}>
                <Grid item xs={12} md={6} className={classes.prompText}>
                        <Typography variant='caption'>{message}</Typography>
        </Grid>
    </Grid>;
};
